console.warn('shipping-estimator-product is loaded!')

// shipping-estimator-product.js
class ShippingEstimatorProduct extends HTMLElement {
  connectedCallback() {
    this.submitButton = this.querySelector('[type="button"]');
    this.submitButton.addEventListener("click", this.estimate.bind(this));
    this.variantId = this.dataset.variantId;
  }

  async estimate() {
    const zip = this.querySelector('[name="shipping-estimator[zip]"]').value;
    const country = this.querySelector('[name="shipping-estimator[country]"]').value;
    const province = this.querySelector('[name="shipping-estimator[province]"]').value;

    this.submitButton.setAttribute("aria-busy", "true");

    // STEP 1 — Backup original cart
    const originalCart = await fetch("/cart.js").then((res) => res.json());

    // STEP 2 — Clear cart
    await fetch("/cart/clear.js", { method: "POST" });

    // STEP 3 — Add ONLY this product
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: this.variantId,
        quantity: 1
      })
    });

    // STEP 4 — Prepare shipping
    const prepare = await fetch(
      `/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
      { method: "POST" }
    );

    if (!prepare.ok) {
      const errorJson = await prepare.json();
      this.renderError(errorJson);
      await this.restoreCart(originalCart);
      this.submitButton.removeAttribute("aria-busy");
      return;
    }

    // STEP 5 — Fetch actual rates
    const rates = await this.fetchAsyncRates(zip, country, province);
    this.renderRates(rates);

    // STEP 6 — Restore cart
    await this.restoreCart(originalCart);

    console.warn("Rates:", rates);

    this.submitButton.removeAttribute("aria-busy");
  }

  async fetchAsyncRates(zip, country, province) {
    const response = await fetch(
      `/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
    );
    const text = await response.text();
    if (text === "null") return this.fetchAsyncRates(zip, country, province);
    return JSON.parse(text).shipping_rates;
  }

  async restoreCart(cart) {
    await fetch("/cart/clear.js", { method: "POST" });

    for (const item of cart.items) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: item.variant_id,
          quantity: item.quantity
        })
      });
    }
  }

  renderRates(rates) {
    this.querySelector(".shipping-estimator__results")?.remove();

    let list = "";
    rates.forEach((rate) => {
      list += `
        <li>${rate.presentment_name}: 
        ${formatMoney(parseFloat(rate.price) * 100)}</li>`;
    });

    const html = `
      <div class="shipping-estimator__results">
        <p>${
          rates.length === 0
            ? window.themeVariables.strings.shippingEstimatorNoResults
            : rates.length === 1
            ? window.themeVariables.strings.shippingEstimatorOneResult
            : window.themeVariables.strings.shippingEstimatorMultipleResults
        }</p>
        ${list ? `<ul class="unordered-list">${list}</ul>` : ""}
      </div>
    `;

    this.insertAdjacentHTML("beforeend", html);
  }

  renderError(errors) {
    this.querySelector(".shipping-estimator__results")?.remove();

    let list = "";
    Object.keys(errors).forEach((k) => {
      list += `<li>${k} ${errors[k]}</li>`;
    });

    const html = `
      <div class="shipping-estimator__results">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="unordered-list">${list}</ul>
      </div>
    `;

    this.insertAdjacentHTML("beforeend", html);
  }
}

window.customElements.define("shipping-estimator-product", ShippingEstimatorProduct);
